module.exports = __webpack_public_path__ + "media/images/promo/drlaurelmellin-3e8b34fb18d174f136c64d7bd06372475d4ac95b506b811d0693eaf0dc6b776c.png";